import React, { useState } from 'react';
import { FieldTypeProps } from 'v2/common/DRM/CustomTab/Field/props';
import styles from './MultiselectField.module.scss';
import Truncate from 'react-truncate';
import { formatTextNewlines } from 'v2/utils/textFormat';
import FieldForm from 'v2/common/DRM/CustomTab/Field/FieldForm/FieldForm';
import CustomContainerCreatableSelect from 'v2/form/CustomSelectors/Multiselect/CustomContainerCreatableSelect';
import CustomContainerSelect from 'v2/form/CustomSelectors/Multiselect/CustomContainerSelect';

type FieldValueProps = {
  value: string;
};

const FieldValue = ({ value }: FieldValueProps) => {
  const [expanded, setExpanded] = useState(false);
  const [truncated, setTruncated] = useState(false);

  const handleTruncate = (_truncated: boolean) => {
    if (_truncated && _truncated !== truncated) {
      setTruncated(_truncated);
    }
  };

  return (
    <>
      <Truncate
        lines={!expanded && 5}
        onTruncate={handleTruncate}
        ellipsis={false}
      >
        {formatTextNewlines(value)}
      </Truncate>

      {truncated ? (
        <div className="mt-3">
          <button
            className={styles.truncateTextToggle}
            type="button"
            onClick={() => {
              setExpanded((expanded) => !expanded);
            }}
          >
            {expanded ? 'Show less' : 'Show more'}
          </button>
        </div>
      ) : null}
    </>
  );
};

const MultiselectField = (props: FieldTypeProps) => {
  const { value, fieldLabel, fieldName, entity } = props;

  if (typeof value !== 'string' && value !== null) return null;

  const values = value ? JSON.parse(value) : [];

  if (!Array.isArray(values)) return null;

  const acceptedValues = entity.accepted_values as Record<string, string[]>;
  const acceptedFieldValues: string[] = acceptedValues?.[fieldName] || [];

  return (
    <FieldForm
      {...props}
      value={values.length > 0 ? values : null}
      formLabel={`Build your ${fieldLabel} list below`}
      content={<FieldValue key={value} value={values.join('\n')} />}
      renderInput={({ field: { onChange } }) => {
        const handleChange = (newValue: string[]) => {
          const jsonValue = JSON.stringify(newValue);
          onChange(jsonValue);
        };

        if (acceptedFieldValues.length > 0) {
          return (
            <CustomContainerSelect
              options={acceptedFieldValues}
              onChange={handleChange}
              value={values}
            />
          );
        }
        return (
          <CustomContainerCreatableSelect
            containerClassName={styles.optionsContainer}
            placeholder="Start typing to add a value"
            formatCreateLabel={(inputValue) => `+ Add "${inputValue}"`}
            options={values}
            onChange={handleChange}
            noOptionsMessage={() => null}
            styles={{
              option: (provided) => ({
                ...provided,
                color: 'var(--primary)',
                backgroundColor: 'white',
              }),
            }}
          />
        );
      }}
    />
  );
};
export default MultiselectField;
